const messages: {
  [key: string]: {
    title: string;
    message: string;
  };
} = {
  APPLICATION_LIMIT_REACHED: {
    title: "Application Limit Is About To Be Reached",
    message:
      "Your current subscription plan allows for the processing of {{noOfApplications}} applications, and that limit is about to be reached. Please upgrade to continue receiving and processing additional applications. ",
  },

  JOB_POST_LIMIT_REACHED: {
    title: "Job Post Limit Reached",
    message:
      "Your current subscription plan allows for the processing of {{noOfJobPosts}} job posts, and that limit has been reached. Please upgrade to continue receiving and processing additional job posts.",
  },

  TEAM_MEMBER_LIMIT_REACHED: {
    title: "Team Member Limit Reached",
    message:
      "Your current subscription plan allows only {{noOfTeamMembers}} active team members, and that limit has been reached. Please upgrade to continue receiving and processing additional team members.",
  },

  CUSTOM_BRANDING_LOCKED: {
    title: "Upgrade Plan To Enable Custom Branding",
    message:
      "Your current subscription plan does not support custom branding. Please upgrade to continue using custom branding.",
  },

  PLAN_EXPIRES_SOON: {
    title: "Plan Expires Soon",
    message:
      "Your current subscription plan is about to expire. Please renew your plan or upgrade to continue receiving and processing additional applications and job posts.",
  },

  PLAN_EXPIRED: {
    title: "Plan Expired",
    message:
      "Your current subscription plan is expired. Please renew your plan to continue receiving and processing additional applications and job posts.",
  },
};

export default messages;
